import { HotelInformation } from '../../shared/models/hotel-information.model';

export interface HotelInformationState {
  data: HotelInformation | null;
  loading: boolean;
  error: string | null;
}

export const initialHotelInformationState: HotelInformationState = {
  data: null,
  loading: false,
  error: null,
};
